import { Injectable } from '@angular/core';

@Injectable()
export class AnalyticsGuard {
  public canActivate(): boolean {
    throw Error('not implemented');
    // return this.identityService.isAuthorized(SectionRole.User, Section.Analytics)
    //     || this.identityService.isAuthorized(SectionRole.Manager, Section.Analytics);
  }
}
